import { Component, OnInit } from '@angular/core';
import { BaseUpdateComponent, BaseDataService, NotificationService } from 'yt-ng-framework';
import { OsobaEmail } from './osoba-email';
import { ActivatedRoute } from '@angular/router';
// import { NotificationsService } from 'angular2-notifications';
import { Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
// import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'yt-osoba-email-update',
  templateUrl: './osoba-email-update.component.html'
})
export class OsobaEmailUpdateComponent
 extends BaseUpdateComponent<OsobaEmail>
 implements OnInit {

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected baseDataService: BaseDataService,
    // protected notificationsService: NotificationsService,
    protected toastrService: NotificationService,
    protected translateService: TranslateService
  ) { 
    super(activatedRoute, baseDataService, toastrService, translateService);    
  }

  ngOnInit() {
    super.ngOnInit();
    this.addValidatorToFc("Naziv", Validators.required, 'required', 'OSOBAEMAIL.NAZIV.VALIDATION.REQUIRED');
    this.addValidatorToFc("Naziv", Validators.maxLength(50), 'maxlength', 'OSOBAEMAIL.NAZIV.VALIDATION.MAXLENGTH');
    this.addValidatorToFc("Opis", Validators.maxLength(100), 'maxlength', 'OSOBAEMAIL.OPIS.VALIDATION.MAXLENGTH');
    this.addValidatorToFc("SvojinaID", Validators.required, 'required', 'OSOBAEMAIL.SVOJINA.VALIDATION.REQUIRED');

  }

}
